@if (isOpen) {
<!-- Backdrop: modal stays fully within the viewport -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center overflow-hidden p-3 sm:p-4"
  [@backdrop]
  role="presentation"
>
  <!-- Overlay -->
  <div class="fixed inset-0 bg-black/40" aria-hidden="true" (click)="onBackdropClick()"></div>

  <!-- Dialog: grows with content up to viewport max; body scrolls when needed -->
  <div
    [@dialog]
    [class]="
      'relative z-10 flex w-full min-w-0 max-h-[calc(100dvh-1.5rem)] flex-col overflow-hidden bg-white rounded-2xl shadow-2xl sm:max-h-[calc(100dvh-2rem)] ' +
      sizeClasses[size]
    "
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title ? 'modal-title' : null"
    [attr.aria-describedby]="description ? 'modal-desc' : null"
  >
    <!-- Loading overlay -->
    @if (isLoading) {
    <div
      class="absolute inset-0 z-20 flex items-center justify-center bg-white/70"
      aria-live="polite"
      aria-label="Loading"
    >
      <svg
        class="h-8 w-8 animate-spin text-gray-400"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
    </div>
    }

    <!-- Custom header slot (overrides default header) -->
    <ng-content select="[modal-header]" />

    <!-- Default header -->
    @if (title || showCloseButton) {
    <div class="flex shrink-0 items-start justify-between gap-3 px-4 pt-4 pb-3 sm:px-6 sm:pt-6 sm:pb-4">
      <div class="flex min-w-0 flex-1 items-center gap-2.5">
        @if (variantIcons[variant]) {
        <span [class]="headerColors[variant]" [innerHTML]="variantIcons[variant]"></span>
        }
        <div class="flex min-w-0 flex-col gap-1">
          @if (title) {
          <h2
            id="modal-title"
            [class]="'text-base font-semibold leading-tight sm:text-lg ' + headerColors[variant]"
          >
            {{ title }}
          </h2>
          }
          @if (subtitle) {
          <p class="text-sm text-(--text-light-gray) sm:text-md">{{ subtitle }}</p>
          }
        </div>
      </div>
      @if (showCloseButton) {
      <button
        type="button"
        aria-label="Close dialog"
        class="shrink-0 -mr-1 -mt-1 cursor-pointer rounded-full bg-[#DA291C] p-1.5 text-white transition-colors hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400"
        (click)="close()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
          />
        </svg>
      </button>
      }
    </div>
    @if (description) {
    <p id="modal-desc" class="shrink-0 -mt-2 px-4 pb-2 text-sm leading-relaxed text-black sm:px-6">
      {{ description }}
    </p>
    }
    }

    <!-- Body slot: flex-1 so it scrolls once the dialog hits the viewport cap -->
    <div
      [class]="
        'ui-modal__body min-h-0 min-w-0 flex-1 overflow-x-hidden overscroll-contain px-4 pb-4 sm:px-6 sm:pb-6 ' +
        (tall ? 'flex flex-col overflow-hidden' : 'overflow-y-auto')
      "
    >
      <ng-content select="[modal-body]" />
    </div>

    <!-- Footer slot -->
    <div class="shrink-0">
      <ng-content select="[modal-footer]" />
    </div>
  </div>
</div>
}
